import axios from 'axios';

export const baseURL = 'https://api.herehome.sa';
// export const baseURL = 'http://localhost:7000';

export const baseUploadURL = 'https://eu2.contabostorage.com/7051a70c2d6e46679352d41254a92ff2:herehhome/';

const user = localStorage.homeHere ? JSON.parse(localStorage.homeHere) : '';

export const HTTP = axios.create({
  baseURL: `${baseURL}/api/`,
  headers: {
    Authorization: `Bearer ${user?.token}`,
    lang: localStorage.lang || 'ar',
    userid: user?._id,
  },
});
